import React from 'react';
import PropTypes from 'prop-types';

class MediaContent extends React.PureComponent {
  render() {
    if (this.props.fileType.indexOf('video') !== -1) {
      return (
        <video width="440" height="275" controls>
          <source src={this.props.url} type="video/mp4" />
          <track src={this.props.url} kind="captions" srcLang="ru" label={this.props.title} />
          Ваш браузер не поддерживает данный вид контента.
        </video>
      );
    }

    return (
      <img
        src={this.props.url}
        alt={this.props.title}
        width="440"
      />
    );
  }
}

MediaContent.propTypes = {
 title: PropTypes.string,
 fileType: PropTypes.string,
 url: PropTypes.string.isRequired,
};

MediaContent.defaultProps = {
  title: '',
  fileType: '',
};

export default MediaContent;
